export default "assets/images/icons/localisation-54c346a3.svg";